import React from 'react';

import * as S from './GfpOfferHeader.styled';

const underText =
  'Escolha os melhores produtos visualizando os lotes pelas GFPs do produtor. Utilize os filtros para fazer uma busca.';

type IProps = {
  siteName?: string;
};

export default function GfpOfferHeader(props: IProps) {
  return (
    <S.Container>
      <S.TextContainer>
        <S.ProductNameContainer>
          <S.BuyGfp>Comprar por GFP:</S.BuyGfp>
          <S.ProductName>{props.siteName}</S.ProductName>
        </S.ProductNameContainer>
        <S.UnderText>{underText}</S.UnderText>
      </S.TextContainer>
      {/* TODO: implementação futura  
      <S.FaqButton>
        Perguntas Frequentes<S.QuestionMark>?</S.QuestionMark>
      </S.FaqButton> */}
    </S.Container>
  );
}
